/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CreatorCenterRouteRouteImport } from './routes/_creator-center/route'
import { Route as CreatorCenterIndexRouteImport } from './routes/_creator-center/index'
import { Route as CreatorCenterAvatarsRouteImport } from './routes/_creator-center/avatars'
import { Route as CreatorCenterFissionRouteImport } from './routes/_creator-center/fission'
import { Route as CreatorCenterScriptTemplateRouteImport } from './routes/_creator-center/script-template'
import { Route as CreatorCenterSkillsRouteImport } from './routes/_creator-center/skills'
import { Route as CreatorCenterStatisticsRouteImport } from './routes/_creator-center/statistics'
import { Route as CreatorCenterAdminAnnouncementsRouteImport } from './routes/_creator-center/admin/announcements'
import { Route as CreatorCenterAdminStatisticsRouteImport } from './routes/_creator-center/admin/statistics'
import { Route as CreatorCenterAvatarsIndexRouteImport } from './routes/_creator-center/avatars.index'
import { Route as CreatorCenterImagesIndexRouteImport } from './routes/_creator-center/images/index'
import { Route as CreatorCenterImagesTranslationRouteImport } from './routes/_creator-center/images/translation'
import { Route as CreatorCenterProductAnalysisRouteImport } from './routes/_creator-center/product/analysis'
import { Route as CreatorCenterTasksImageRouteImport } from './routes/_creator-center/tasks/image'
import { Route as CreatorCenterVideoAnalysisRouteImport } from './routes/_creator-center/video/analysis'
import { Route as CreatorCenterVideoCreateRouteImport } from './routes/_creator-center/video/create'
import { Route as CreatorCenterVideoEditRouteImport } from './routes/_creator-center/video/edit'
import { Route as CreatorCenterVideoHistoryRouteImport } from './routes/_creator-center/video/history'
import { Route as CreatorCenterVideoQualityRestorationRouteImport } from './routes/_creator-center/video/quality-restoration'
import { Route as CreatorCenterVideoReferenceCreateRouteImport } from './routes/_creator-center/video/reference-create'
import { Route as CreatorCenterVideoReplicationRouteImport } from './routes/_creator-center/video/replication'
import { Route as CreatorCenterVideoScriptRouteImport } from './routes/_creator-center/video/script'
import { Route as CreatorCenterVideoSmartEraseRouteImport } from './routes/_creator-center/video/smart-erase'
import { Route as CreatorCenterVideoTranslationRouteImport } from './routes/_creator-center/video/translation'
import { Route as CreatorCenterAdminStatisticsIndexRouteImport } from './routes/_creator-center/admin/statistics.index'
import { Route as CreatorCenterAdminStatisticsScriptRouteImport } from './routes/_creator-center/admin/statistics.script'
import { Route as CreatorCenterAdminStatisticsTaskRouteImport } from './routes/_creator-center/admin/statistics.task'
import { Route as CreatorCenterAdminStatisticsUsageLimitRouteImport } from './routes/_creator-center/admin/statistics.usage-limit'
import { Route as CreatorCenterAdminStatisticsVideoRouteImport } from './routes/_creator-center/admin/statistics.video'
import { Route as CreatorCenterVideoLongReferenceCreateRouteImport } from './routes/_creator-center/video/long.reference-create'

const CreatorCenterRouteRoute = CreatorCenterRouteRouteImport.update({
  id: '/_creator-center',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorCenterIndexRoute = CreatorCenterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterAvatarsRoute = CreatorCenterAvatarsRouteImport.update({
  id: '/avatars',
  path: '/avatars',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterFissionRoute = CreatorCenterFissionRouteImport.update({
  id: '/fission',
  path: '/fission',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterScriptTemplateRoute =
  CreatorCenterScriptTemplateRouteImport.update({
    id: '/script-template',
    path: '/script-template',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterSkillsRoute = CreatorCenterSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterStatisticsRoute = CreatorCenterStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterAdminAnnouncementsRoute =
  CreatorCenterAdminAnnouncementsRouteImport.update({
    id: '/admin/announcements',
    path: '/admin/announcements',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterAdminStatisticsRoute =
  CreatorCenterAdminStatisticsRouteImport.update({
    id: '/admin/statistics',
    path: '/admin/statistics',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterAvatarsIndexRoute =
  CreatorCenterAvatarsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CreatorCenterAvatarsRoute,
  } as any)
const CreatorCenterImagesIndexRoute =
  CreatorCenterImagesIndexRouteImport.update({
    id: '/images/',
    path: '/images/',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterImagesTranslationRoute =
  CreatorCenterImagesTranslationRouteImport.update({
    id: '/images/translation',
    path: '/images/translation',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterProductAnalysisRoute =
  CreatorCenterProductAnalysisRouteImport.update({
    id: '/product/analysis',
    path: '/product/analysis',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterTasksImageRoute = CreatorCenterTasksImageRouteImport.update({
  id: '/tasks/image',
  path: '/tasks/image',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterVideoAnalysisRoute =
  CreatorCenterVideoAnalysisRouteImport.update({
    id: '/video/analysis',
    path: '/video/analysis',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoCreateRoute =
  CreatorCenterVideoCreateRouteImport.update({
    id: '/video/create',
    path: '/video/create',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoEditRoute = CreatorCenterVideoEditRouteImport.update({
  id: '/video/edit',
  path: '/video/edit',
  getParentRoute: () => CreatorCenterRouteRoute,
} as any)
const CreatorCenterVideoHistoryRoute =
  CreatorCenterVideoHistoryRouteImport.update({
    id: '/video/history',
    path: '/video/history',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoQualityRestorationRoute =
  CreatorCenterVideoQualityRestorationRouteImport.update({
    id: '/video/quality-restoration',
    path: '/video/quality-restoration',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoReferenceCreateRoute =
  CreatorCenterVideoReferenceCreateRouteImport.update({
    id: '/video/reference-create',
    path: '/video/reference-create',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoReplicationRoute =
  CreatorCenterVideoReplicationRouteImport.update({
    id: '/video/replication',
    path: '/video/replication',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoScriptRoute =
  CreatorCenterVideoScriptRouteImport.update({
    id: '/video/script',
    path: '/video/script',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoSmartEraseRoute =
  CreatorCenterVideoSmartEraseRouteImport.update({
    id: '/video/smart-erase',
    path: '/video/smart-erase',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterVideoTranslationRoute =
  CreatorCenterVideoTranslationRouteImport.update({
    id: '/video/translation',
    path: '/video/translation',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)
const CreatorCenterAdminStatisticsIndexRoute =
  CreatorCenterAdminStatisticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CreatorCenterAdminStatisticsRoute,
  } as any)
const CreatorCenterAdminStatisticsScriptRoute =
  CreatorCenterAdminStatisticsScriptRouteImport.update({
    id: '/script',
    path: '/script',
    getParentRoute: () => CreatorCenterAdminStatisticsRoute,
  } as any)
const CreatorCenterAdminStatisticsTaskRoute =
  CreatorCenterAdminStatisticsTaskRouteImport.update({
    id: '/task',
    path: '/task',
    getParentRoute: () => CreatorCenterAdminStatisticsRoute,
  } as any)
const CreatorCenterAdminStatisticsUsageLimitRoute =
  CreatorCenterAdminStatisticsUsageLimitRouteImport.update({
    id: '/usage-limit',
    path: '/usage-limit',
    getParentRoute: () => CreatorCenterAdminStatisticsRoute,
  } as any)
const CreatorCenterAdminStatisticsVideoRoute =
  CreatorCenterAdminStatisticsVideoRouteImport.update({
    id: '/video',
    path: '/video',
    getParentRoute: () => CreatorCenterAdminStatisticsRoute,
  } as any)
const CreatorCenterVideoLongReferenceCreateRoute =
  CreatorCenterVideoLongReferenceCreateRouteImport.update({
    id: '/video/long/reference-create',
    path: '/video/long/reference-create',
    getParentRoute: () => CreatorCenterRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof CreatorCenterIndexRoute
  '/avatars': typeof CreatorCenterAvatarsRouteWithChildren
  '/fission': typeof CreatorCenterFissionRoute
  '/script-template': typeof CreatorCenterScriptTemplateRoute
  '/skills': typeof CreatorCenterSkillsRoute
  '/statistics': typeof CreatorCenterStatisticsRoute
  '/admin/announcements': typeof CreatorCenterAdminAnnouncementsRoute
  '/admin/statistics': typeof CreatorCenterAdminStatisticsRouteWithChildren
  '/images/translation': typeof CreatorCenterImagesTranslationRoute
  '/product/analysis': typeof CreatorCenterProductAnalysisRoute
  '/tasks/image': typeof CreatorCenterTasksImageRoute
  '/video/analysis': typeof CreatorCenterVideoAnalysisRoute
  '/video/create': typeof CreatorCenterVideoCreateRoute
  '/video/edit': typeof CreatorCenterVideoEditRoute
  '/video/history': typeof CreatorCenterVideoHistoryRoute
  '/video/quality-restoration': typeof CreatorCenterVideoQualityRestorationRoute
  '/video/reference-create': typeof CreatorCenterVideoReferenceCreateRoute
  '/video/replication': typeof CreatorCenterVideoReplicationRoute
  '/video/script': typeof CreatorCenterVideoScriptRoute
  '/video/smart-erase': typeof CreatorCenterVideoSmartEraseRoute
  '/video/translation': typeof CreatorCenterVideoTranslationRoute
  '/avatars/': typeof CreatorCenterAvatarsIndexRoute
  '/images/': typeof CreatorCenterImagesIndexRoute
  '/admin/statistics/script': typeof CreatorCenterAdminStatisticsScriptRoute
  '/admin/statistics/task': typeof CreatorCenterAdminStatisticsTaskRoute
  '/admin/statistics/usage-limit': typeof CreatorCenterAdminStatisticsUsageLimitRoute
  '/admin/statistics/video': typeof CreatorCenterAdminStatisticsVideoRoute
  '/video/long/reference-create': typeof CreatorCenterVideoLongReferenceCreateRoute
  '/admin/statistics/': typeof CreatorCenterAdminStatisticsIndexRoute
}
export interface FileRoutesByTo {
  '/fission': typeof CreatorCenterFissionRoute
  '/script-template': typeof CreatorCenterScriptTemplateRoute
  '/skills': typeof CreatorCenterSkillsRoute
  '/statistics': typeof CreatorCenterStatisticsRoute
  '/': typeof CreatorCenterIndexRoute
  '/admin/announcements': typeof CreatorCenterAdminAnnouncementsRoute
  '/images/translation': typeof CreatorCenterImagesTranslationRoute
  '/product/analysis': typeof CreatorCenterProductAnalysisRoute
  '/tasks/image': typeof CreatorCenterTasksImageRoute
  '/video/analysis': typeof CreatorCenterVideoAnalysisRoute
  '/video/create': typeof CreatorCenterVideoCreateRoute
  '/video/edit': typeof CreatorCenterVideoEditRoute
  '/video/history': typeof CreatorCenterVideoHistoryRoute
  '/video/quality-restoration': typeof CreatorCenterVideoQualityRestorationRoute
  '/video/reference-create': typeof CreatorCenterVideoReferenceCreateRoute
  '/video/replication': typeof CreatorCenterVideoReplicationRoute
  '/video/script': typeof CreatorCenterVideoScriptRoute
  '/video/smart-erase': typeof CreatorCenterVideoSmartEraseRoute
  '/video/translation': typeof CreatorCenterVideoTranslationRoute
  '/avatars': typeof CreatorCenterAvatarsIndexRoute
  '/images': typeof CreatorCenterImagesIndexRoute
  '/admin/statistics/script': typeof CreatorCenterAdminStatisticsScriptRoute
  '/admin/statistics/task': typeof CreatorCenterAdminStatisticsTaskRoute
  '/admin/statistics/usage-limit': typeof CreatorCenterAdminStatisticsUsageLimitRoute
  '/admin/statistics/video': typeof CreatorCenterAdminStatisticsVideoRoute
  '/video/long/reference-create': typeof CreatorCenterVideoLongReferenceCreateRoute
  '/admin/statistics': typeof CreatorCenterAdminStatisticsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_creator-center': typeof CreatorCenterRouteRouteWithChildren
  '/_creator-center/avatars': typeof CreatorCenterAvatarsRouteWithChildren
  '/_creator-center/fission': typeof CreatorCenterFissionRoute
  '/_creator-center/script-template': typeof CreatorCenterScriptTemplateRoute
  '/_creator-center/skills': typeof CreatorCenterSkillsRoute
  '/_creator-center/statistics': typeof CreatorCenterStatisticsRoute
  '/_creator-center/': typeof CreatorCenterIndexRoute
  '/_creator-center/admin/announcements': typeof CreatorCenterAdminAnnouncementsRoute
  '/_creator-center/admin/statistics': typeof CreatorCenterAdminStatisticsRouteWithChildren
  '/_creator-center/images/translation': typeof CreatorCenterImagesTranslationRoute
  '/_creator-center/product/analysis': typeof CreatorCenterProductAnalysisRoute
  '/_creator-center/tasks/image': typeof CreatorCenterTasksImageRoute
  '/_creator-center/video/analysis': typeof CreatorCenterVideoAnalysisRoute
  '/_creator-center/video/create': typeof CreatorCenterVideoCreateRoute
  '/_creator-center/video/edit': typeof CreatorCenterVideoEditRoute
  '/_creator-center/video/history': typeof CreatorCenterVideoHistoryRoute
  '/_creator-center/video/quality-restoration': typeof CreatorCenterVideoQualityRestorationRoute
  '/_creator-center/video/reference-create': typeof CreatorCenterVideoReferenceCreateRoute
  '/_creator-center/video/replication': typeof CreatorCenterVideoReplicationRoute
  '/_creator-center/video/script': typeof CreatorCenterVideoScriptRoute
  '/_creator-center/video/smart-erase': typeof CreatorCenterVideoSmartEraseRoute
  '/_creator-center/video/translation': typeof CreatorCenterVideoTranslationRoute
  '/_creator-center/avatars/': typeof CreatorCenterAvatarsIndexRoute
  '/_creator-center/images/': typeof CreatorCenterImagesIndexRoute
  '/_creator-center/admin/statistics/script': typeof CreatorCenterAdminStatisticsScriptRoute
  '/_creator-center/admin/statistics/task': typeof CreatorCenterAdminStatisticsTaskRoute
  '/_creator-center/admin/statistics/usage-limit': typeof CreatorCenterAdminStatisticsUsageLimitRoute
  '/_creator-center/admin/statistics/video': typeof CreatorCenterAdminStatisticsVideoRoute
  '/_creator-center/video/long/reference-create': typeof CreatorCenterVideoLongReferenceCreateRoute
  '/_creator-center/admin/statistics/': typeof CreatorCenterAdminStatisticsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/avatars'
    | '/fission'
    | '/script-template'
    | '/skills'
    | '/statistics'
    | '/admin/announcements'
    | '/admin/statistics'
    | '/images/translation'
    | '/product/analysis'
    | '/tasks/image'
    | '/video/analysis'
    | '/video/create'
    | '/video/edit'
    | '/video/history'
    | '/video/quality-restoration'
    | '/video/reference-create'
    | '/video/replication'
    | '/video/script'
    | '/video/smart-erase'
    | '/video/translation'
    | '/avatars/'
    | '/images/'
    | '/admin/statistics/script'
    | '/admin/statistics/task'
    | '/admin/statistics/usage-limit'
    | '/admin/statistics/video'
    | '/video/long/reference-create'
    | '/admin/statistics/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/fission'
    | '/script-template'
    | '/skills'
    | '/statistics'
    | '/'
    | '/admin/announcements'
    | '/images/translation'
    | '/product/analysis'
    | '/tasks/image'
    | '/video/analysis'
    | '/video/create'
    | '/video/edit'
    | '/video/history'
    | '/video/quality-restoration'
    | '/video/reference-create'
    | '/video/replication'
    | '/video/script'
    | '/video/smart-erase'
    | '/video/translation'
    | '/avatars'
    | '/images'
    | '/admin/statistics/script'
    | '/admin/statistics/task'
    | '/admin/statistics/usage-limit'
    | '/admin/statistics/video'
    | '/video/long/reference-create'
    | '/admin/statistics'
  id:
    | '__root__'
    | '/_creator-center'
    | '/_creator-center/avatars'
    | '/_creator-center/fission'
    | '/_creator-center/script-template'
    | '/_creator-center/skills'
    | '/_creator-center/statistics'
    | '/_creator-center/'
    | '/_creator-center/admin/announcements'
    | '/_creator-center/admin/statistics'
    | '/_creator-center/images/translation'
    | '/_creator-center/product/analysis'
    | '/_creator-center/tasks/image'
    | '/_creator-center/video/analysis'
    | '/_creator-center/video/create'
    | '/_creator-center/video/edit'
    | '/_creator-center/video/history'
    | '/_creator-center/video/quality-restoration'
    | '/_creator-center/video/reference-create'
    | '/_creator-center/video/replication'
    | '/_creator-center/video/script'
    | '/_creator-center/video/smart-erase'
    | '/_creator-center/video/translation'
    | '/_creator-center/avatars/'
    | '/_creator-center/images/'
    | '/_creator-center/admin/statistics/script'
    | '/_creator-center/admin/statistics/task'
    | '/_creator-center/admin/statistics/usage-limit'
    | '/_creator-center/admin/statistics/video'
    | '/_creator-center/video/long/reference-create'
    | '/_creator-center/admin/statistics/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CreatorCenterRouteRoute: typeof CreatorCenterRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_creator-center': {
      id: '/_creator-center'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CreatorCenterRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_creator-center/': {
      id: '/_creator-center/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof CreatorCenterIndexRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/avatars': {
      id: '/_creator-center/avatars'
      path: '/avatars'
      fullPath: '/avatars'
      preLoaderRoute: typeof CreatorCenterAvatarsRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/fission': {
      id: '/_creator-center/fission'
      path: '/fission'
      fullPath: '/fission'
      preLoaderRoute: typeof CreatorCenterFissionRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/script-template': {
      id: '/_creator-center/script-template'
      path: '/script-template'
      fullPath: '/script-template'
      preLoaderRoute: typeof CreatorCenterScriptTemplateRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/skills': {
      id: '/_creator-center/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof CreatorCenterSkillsRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/statistics': {
      id: '/_creator-center/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof CreatorCenterStatisticsRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/admin/announcements': {
      id: '/_creator-center/admin/announcements'
      path: '/admin/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof CreatorCenterAdminAnnouncementsRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/admin/statistics': {
      id: '/_creator-center/admin/statistics'
      path: '/admin/statistics'
      fullPath: '/admin/statistics'
      preLoaderRoute: typeof CreatorCenterAdminStatisticsRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/avatars/': {
      id: '/_creator-center/avatars/'
      path: '/'
      fullPath: '/avatars/'
      preLoaderRoute: typeof CreatorCenterAvatarsIndexRouteImport
      parentRoute: typeof CreatorCenterAvatarsRoute
    }
    '/_creator-center/images/': {
      id: '/_creator-center/images/'
      path: '/images'
      fullPath: '/images/'
      preLoaderRoute: typeof CreatorCenterImagesIndexRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/images/translation': {
      id: '/_creator-center/images/translation'
      path: '/images/translation'
      fullPath: '/images/translation'
      preLoaderRoute: typeof CreatorCenterImagesTranslationRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/product/analysis': {
      id: '/_creator-center/product/analysis'
      path: '/product/analysis'
      fullPath: '/product/analysis'
      preLoaderRoute: typeof CreatorCenterProductAnalysisRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/tasks/image': {
      id: '/_creator-center/tasks/image'
      path: '/tasks/image'
      fullPath: '/tasks/image'
      preLoaderRoute: typeof CreatorCenterTasksImageRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/analysis': {
      id: '/_creator-center/video/analysis'
      path: '/video/analysis'
      fullPath: '/video/analysis'
      preLoaderRoute: typeof CreatorCenterVideoAnalysisRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/create': {
      id: '/_creator-center/video/create'
      path: '/video/create'
      fullPath: '/video/create'
      preLoaderRoute: typeof CreatorCenterVideoCreateRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/edit': {
      id: '/_creator-center/video/edit'
      path: '/video/edit'
      fullPath: '/video/edit'
      preLoaderRoute: typeof CreatorCenterVideoEditRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/history': {
      id: '/_creator-center/video/history'
      path: '/video/history'
      fullPath: '/video/history'
      preLoaderRoute: typeof CreatorCenterVideoHistoryRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/quality-restoration': {
      id: '/_creator-center/video/quality-restoration'
      path: '/video/quality-restoration'
      fullPath: '/video/quality-restoration'
      preLoaderRoute: typeof CreatorCenterVideoQualityRestorationRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/reference-create': {
      id: '/_creator-center/video/reference-create'
      path: '/video/reference-create'
      fullPath: '/video/reference-create'
      preLoaderRoute: typeof CreatorCenterVideoReferenceCreateRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/replication': {
      id: '/_creator-center/video/replication'
      path: '/video/replication'
      fullPath: '/video/replication'
      preLoaderRoute: typeof CreatorCenterVideoReplicationRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/script': {
      id: '/_creator-center/video/script'
      path: '/video/script'
      fullPath: '/video/script'
      preLoaderRoute: typeof CreatorCenterVideoScriptRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/smart-erase': {
      id: '/_creator-center/video/smart-erase'
      path: '/video/smart-erase'
      fullPath: '/video/smart-erase'
      preLoaderRoute: typeof CreatorCenterVideoSmartEraseRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/video/translation': {
      id: '/_creator-center/video/translation'
      path: '/video/translation'
      fullPath: '/video/translation'
      preLoaderRoute: typeof CreatorCenterVideoTranslationRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
    '/_creator-center/admin/statistics/': {
      id: '/_creator-center/admin/statistics/'
      path: '/'
      fullPath: '/admin/statistics/'
      preLoaderRoute: typeof CreatorCenterAdminStatisticsIndexRouteImport
      parentRoute: typeof CreatorCenterAdminStatisticsRoute
    }
    '/_creator-center/admin/statistics/script': {
      id: '/_creator-center/admin/statistics/script'
      path: '/script'
      fullPath: '/admin/statistics/script'
      preLoaderRoute: typeof CreatorCenterAdminStatisticsScriptRouteImport
      parentRoute: typeof CreatorCenterAdminStatisticsRoute
    }
    '/_creator-center/admin/statistics/task': {
      id: '/_creator-center/admin/statistics/task'
      path: '/task'
      fullPath: '/admin/statistics/task'
      preLoaderRoute: typeof CreatorCenterAdminStatisticsTaskRouteImport
      parentRoute: typeof CreatorCenterAdminStatisticsRoute
    }
    '/_creator-center/admin/statistics/usage-limit': {
      id: '/_creator-center/admin/statistics/usage-limit'
      path: '/usage-limit'
      fullPath: '/admin/statistics/usage-limit'
      preLoaderRoute: typeof CreatorCenterAdminStatisticsUsageLimitRouteImport
      parentRoute: typeof CreatorCenterAdminStatisticsRoute
    }
    '/_creator-center/admin/statistics/video': {
      id: '/_creator-center/admin/statistics/video'
      path: '/video'
      fullPath: '/admin/statistics/video'
      preLoaderRoute: typeof CreatorCenterAdminStatisticsVideoRouteImport
      parentRoute: typeof CreatorCenterAdminStatisticsRoute
    }
    '/_creator-center/video/long/reference-create': {
      id: '/_creator-center/video/long/reference-create'
      path: '/video/long/reference-create'
      fullPath: '/video/long/reference-create'
      preLoaderRoute: typeof CreatorCenterVideoLongReferenceCreateRouteImport
      parentRoute: typeof CreatorCenterRouteRoute
    }
  }
}

interface CreatorCenterAvatarsRouteChildren {
  CreatorCenterAvatarsIndexRoute: typeof CreatorCenterAvatarsIndexRoute
}

const CreatorCenterAvatarsRouteChildren: CreatorCenterAvatarsRouteChildren = {
  CreatorCenterAvatarsIndexRoute: CreatorCenterAvatarsIndexRoute,
}

const CreatorCenterAvatarsRouteWithChildren =
  CreatorCenterAvatarsRoute._addFileChildren(CreatorCenterAvatarsRouteChildren)

interface CreatorCenterAdminStatisticsRouteChildren {
  CreatorCenterAdminStatisticsScriptRoute: typeof CreatorCenterAdminStatisticsScriptRoute
  CreatorCenterAdminStatisticsTaskRoute: typeof CreatorCenterAdminStatisticsTaskRoute
  CreatorCenterAdminStatisticsUsageLimitRoute: typeof CreatorCenterAdminStatisticsUsageLimitRoute
  CreatorCenterAdminStatisticsVideoRoute: typeof CreatorCenterAdminStatisticsVideoRoute
  CreatorCenterAdminStatisticsIndexRoute: typeof CreatorCenterAdminStatisticsIndexRoute
}

const CreatorCenterAdminStatisticsRouteChildren: CreatorCenterAdminStatisticsRouteChildren =
  {
    CreatorCenterAdminStatisticsScriptRoute:
      CreatorCenterAdminStatisticsScriptRoute,
    CreatorCenterAdminStatisticsTaskRoute:
      CreatorCenterAdminStatisticsTaskRoute,
    CreatorCenterAdminStatisticsUsageLimitRoute:
      CreatorCenterAdminStatisticsUsageLimitRoute,
    CreatorCenterAdminStatisticsVideoRoute:
      CreatorCenterAdminStatisticsVideoRoute,
    CreatorCenterAdminStatisticsIndexRoute:
      CreatorCenterAdminStatisticsIndexRoute,
  }

const CreatorCenterAdminStatisticsRouteWithChildren =
  CreatorCenterAdminStatisticsRoute._addFileChildren(
    CreatorCenterAdminStatisticsRouteChildren,
  )

interface CreatorCenterRouteRouteChildren {
  CreatorCenterAvatarsRoute: typeof CreatorCenterAvatarsRouteWithChildren
  CreatorCenterFissionRoute: typeof CreatorCenterFissionRoute
  CreatorCenterScriptTemplateRoute: typeof CreatorCenterScriptTemplateRoute
  CreatorCenterSkillsRoute: typeof CreatorCenterSkillsRoute
  CreatorCenterStatisticsRoute: typeof CreatorCenterStatisticsRoute
  CreatorCenterIndexRoute: typeof CreatorCenterIndexRoute
  CreatorCenterAdminAnnouncementsRoute: typeof CreatorCenterAdminAnnouncementsRoute
  CreatorCenterAdminStatisticsRoute: typeof CreatorCenterAdminStatisticsRouteWithChildren
  CreatorCenterImagesTranslationRoute: typeof CreatorCenterImagesTranslationRoute
  CreatorCenterProductAnalysisRoute: typeof CreatorCenterProductAnalysisRoute
  CreatorCenterTasksImageRoute: typeof CreatorCenterTasksImageRoute
  CreatorCenterVideoAnalysisRoute: typeof CreatorCenterVideoAnalysisRoute
  CreatorCenterVideoCreateRoute: typeof CreatorCenterVideoCreateRoute
  CreatorCenterVideoEditRoute: typeof CreatorCenterVideoEditRoute
  CreatorCenterVideoHistoryRoute: typeof CreatorCenterVideoHistoryRoute
  CreatorCenterVideoQualityRestorationRoute: typeof CreatorCenterVideoQualityRestorationRoute
  CreatorCenterVideoReferenceCreateRoute: typeof CreatorCenterVideoReferenceCreateRoute
  CreatorCenterVideoReplicationRoute: typeof CreatorCenterVideoReplicationRoute
  CreatorCenterVideoScriptRoute: typeof CreatorCenterVideoScriptRoute
  CreatorCenterVideoSmartEraseRoute: typeof CreatorCenterVideoSmartEraseRoute
  CreatorCenterVideoTranslationRoute: typeof CreatorCenterVideoTranslationRoute
  CreatorCenterImagesIndexRoute: typeof CreatorCenterImagesIndexRoute
  CreatorCenterVideoLongReferenceCreateRoute: typeof CreatorCenterVideoLongReferenceCreateRoute
}

const CreatorCenterRouteRouteChildren: CreatorCenterRouteRouteChildren = {
  CreatorCenterAvatarsRoute: CreatorCenterAvatarsRouteWithChildren,
  CreatorCenterFissionRoute: CreatorCenterFissionRoute,
  CreatorCenterScriptTemplateRoute: CreatorCenterScriptTemplateRoute,
  CreatorCenterSkillsRoute: CreatorCenterSkillsRoute,
  CreatorCenterStatisticsRoute: CreatorCenterStatisticsRoute,
  CreatorCenterIndexRoute: CreatorCenterIndexRoute,
  CreatorCenterAdminAnnouncementsRoute: CreatorCenterAdminAnnouncementsRoute,
  CreatorCenterAdminStatisticsRoute:
    CreatorCenterAdminStatisticsRouteWithChildren,
  CreatorCenterImagesTranslationRoute: CreatorCenterImagesTranslationRoute,
  CreatorCenterProductAnalysisRoute: CreatorCenterProductAnalysisRoute,
  CreatorCenterTasksImageRoute: CreatorCenterTasksImageRoute,
  CreatorCenterVideoAnalysisRoute: CreatorCenterVideoAnalysisRoute,
  CreatorCenterVideoCreateRoute: CreatorCenterVideoCreateRoute,
  CreatorCenterVideoEditRoute: CreatorCenterVideoEditRoute,
  CreatorCenterVideoHistoryRoute: CreatorCenterVideoHistoryRoute,
  CreatorCenterVideoQualityRestorationRoute:
    CreatorCenterVideoQualityRestorationRoute,
  CreatorCenterVideoReferenceCreateRoute:
    CreatorCenterVideoReferenceCreateRoute,
  CreatorCenterVideoReplicationRoute: CreatorCenterVideoReplicationRoute,
  CreatorCenterVideoScriptRoute: CreatorCenterVideoScriptRoute,
  CreatorCenterVideoSmartEraseRoute: CreatorCenterVideoSmartEraseRoute,
  CreatorCenterVideoTranslationRoute: CreatorCenterVideoTranslationRoute,
  CreatorCenterImagesIndexRoute: CreatorCenterImagesIndexRoute,
  CreatorCenterVideoLongReferenceCreateRoute:
    CreatorCenterVideoLongReferenceCreateRoute,
}

const CreatorCenterRouteRouteWithChildren =
  CreatorCenterRouteRoute._addFileChildren(CreatorCenterRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CreatorCenterRouteRoute: CreatorCenterRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
